import { render, staticRenderFns } from "./PresetRegimenNew.vue?vue&type=template&id=2e20ba76&scoped=true"
import script from "./PresetRegimenNew.vue?vue&type=script&lang=js"
export * from "./PresetRegimenNew.vue?vue&type=script&lang=js"
import style0 from "./PresetRegimenNew.vue?vue&type=style&index=0&id=2e20ba76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20ba76",
  null
  
)

export default component.exports